import {
  Combobox,
  ComboboxContent,
  ComboboxItem,
  ComboboxTrigger,
} from '@/components/Combobox/Combobox';
import { Avatar, AvatarFallback } from '@e2n/ui';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import { useTranslation } from 'react-i18next';
import { useManager } from '@/domain/mitarbeiter/shared/hooks/useManager/useManager';

export function ErinnerungAnMultiSelect({
  values,
  handleChange,
  arbeitsbereichId,
}: {
  values: string[];
  handleChange: (value: string[]) => void;
  arbeitsbereichId?: string | undefined;
}) {
  const { t } = useTranslation();
  const { currentStandort } = useStandortContext();
  const { manager } = useManager(currentStandort.id);

  const managerFiltered = arbeitsbereichId
    ? manager.filter(
        (m) => !m.ausgeblendeteArbeitsbereichIds.includes(arbeitsbereichId),
      )
    : manager;

  const options = managerFiltered.map((m) => ({
    value: m.id,
    label: `${m.vorname} ${m.nachname}`,
    vorname: m.vorname,
    nachname: m.nachname,
  }));

  const selectedValues = options
    .filter((ab) => values.includes(ab.value))
    .map((option) => option.value);

  return (
    <Combobox<(typeof options)[number]>
      options={options}
      values={selectedValues}
      onValuesChange={handleChange}
      placeholder={t(
        `domain.mitarbeiter.create.steps.person.arbeitsbereiche.form.sekundaereArbeitsbereiche.placeholder`,
      )}>
      <ComboboxTrigger />
      <ComboboxContent<(typeof options)[number]>>
        {(options) =>
          options.map((option) => (
            <ComboboxItem key={option.value} value={option.value}>
              <div className="flex gap-2 items-center">
                <Avatar className="size-8">
                  <AvatarFallback className="text-neutrals-900 text-xs font-semibold leading-4">{`${option.vorname.charAt(0).toUpperCase()}${option.nachname.charAt(0).toUpperCase()}`}</AvatarFallback>
                </Avatar>
                <span className="text-neutrals-900 text-sm font-normal leading-5">
                  {option.label}
                </span>
              </div>
            </ComboboxItem>
          ))
        }
      </ComboboxContent>
    </Combobox>
  );
}
